<template>
    <div class="container">
        <Header :headerData="headerData"></Header>

        <div class="operate_btn">
            <a-select
                v-if="userInfo.tenant_id == 1"
                class="query_field"
                v-model:value="searchForm.tenant_id"
                :placeholder="t('upgradeRules.tenant')"
                :options="tenantOptions"
                allowClear
                style="margin-right:10px;width:200px"
                @change="handleSelectChange"
            ></a-select>
            <a-input v-model:value="searchForm.part_no" allowClear :placeholder="t('partProjectTenant.part_no')" style="margin-right:10px;width:200px" @change="(event)=>handleInputChange('part_no', event)"/>
            <a-input v-model:value="searchForm.project_no" allowClear :placeholder="t('partProjectTenant.project_no')" style="margin-right:10px;width:200px" @change="(event)=>handleInputChange('project_no', event)"/>
            <a-button type="primary" size="small" style="margin-right:10px" @click="handleSearch">
                <img src="@/assets/image/search.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('base.search') }}
            </a-button>
        </div>

        <a-button type="primary" size="small" style="margin:10px 0" @click="handle('add')">
            <component :is="$antIcons['PlusOutlined']" style="margin-right: 5px;margin-top:-3px"></component>
            {{ t('upgradeRules.add') }}
        </a-button>

        <Table
            ref="tableRef"
            class="table"
            :table="table"
            @handleChangePagination="handleChangePagination"
            @expandRow="expandRow"
        >
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button size="small" type="primary" style="margin-right:10px" @click="handle('edit', props.record)">
                        {{ t('upgradeRules.edit') }}
                    </a-button>
                </template>
            </template>
        </Table>

        <a-modal 
            v-model:open="visible"
            :closable="false"
            :width="750"
            centered
            :maskClosable="false"
            :cancelText="t('base.cancel')"
            :okText="t('base.confirm')"
            @ok="addPartProjectTenant"
        >
            <div class="queryUserTitle">{{ modal_title }}</div>
            <div class="form_item">
                <div class="form_label">{{ t('partProjectTenant.tenant') }} <span class="required">*</span></div>
                <a-select 
                    style="width: 100%"
                    v-model:value="addForm.tenant_id"  
                    :options="tenantOptions" 
                />
            </div>
            <div class="form_item">
                <div class="form_label">{{ t('partProjectTenant.part_no') }} <span class="required">*</span></div>
                <a-input v-model:value="addForm.part_no"  />
            </div>
            <div class="form_item">
                <div class="form_label">{{ t('partProjectTenant.project_no') }} <span class="required">*</span></div>
                <a-input v-model:value="addForm.project_no" />
            </div>
        </a-modal>
    </div>
</template>

<script setup>
    import { ref, reactive, onMounted } from 'vue';
    import Table from '@/components/Table.vue';
    import Header from "@/layouts/component/Header.vue";
    import { getWeek } from '@/hooks/useGetWeek';
    import { useI18n } from 'vue-i18n';
    import { PartProjectTenantApi } from '@/api/PartProjectTenantApi.js';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { message, Modal } from 'ant-design-vue';
    import { debounce } from '@/utils/global';

    const { t } = useI18n();

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const operate_type = ref('add')
    const modal_title = ref('')
    const tenantOptions = ref([])
    const tenantObj = reactive({})
    const rowData = ref({})
    const searchForm = ref({
        part_no: '',
        project_no: '',
        tenant_id: null,
    })
    const visible = ref(false)
    const addForm = ref({
        part_no: '',
        project_no: '',
        tenant_id: null,
    })

    const headerData = ref({
        menu:'menu.PartProjectTenant',
        menu_desc: '',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    
    
    const table = ref({
        data: [],
        columns: [
            { title: t('partProjectTenant.tenant'), dataIndex: 'tenant', key: 'tenant', width: 140, resizable: true, fixed: 'left' },
            { title: t('partProjectTenant.part_no'), dataIndex: 'part_no', key: 'part_no', width: 160 },
            { title: t('partProjectTenant.project_no'), dataIndex: 'project_no', key: 'project_no', width: 160 },
            { title: t('base.operate'), key: 'action', width: 90, fixed: 'right' },
        ],
        configs: {
            table: {
                rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1260,
                y: 520,
            },
            rowSelection: false,
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                position: ['bottomLeft'],
                showSizeChanger: true,
                pageSizeOptions: ['10','20','50'],
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        }
    })

    const handleInputChange = debounce(()=>{
        // searchForm.value[key] = event.target.value.trim()
        handleSearch()
    }, 500)

    const handleSelectChange = ()=>{
        handleSearch()
    }

    const handleSearch = ()=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const handleChangePagination =  (config)=> {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }


    const handle = (type, record)=>{
        switch(type){
            case 'add':
                addForm.value.part_no = ''
                addForm.value.project_no = ''
                addForm.value.tenant_id = null
                visible.value = true
                operate_type.value = 'add'
                modal_title.value = t('base.add')
                break;
            case 'edit':
                visible.value = true
                modal_title.value = t('base.edit')
                operate_type.value = 'edit'
                rowData.value = record
                addForm.value.part_no = record.part_no
                addForm.value.project_no = record.project_no
                addForm.value.tenant_id = record.tenant_id
                break;
        }
    }


    const getList = async()=>{
        let params = {
            part_no: searchForm.value.part_no.trim(),
            project_no: searchForm.value.project_no.trim(),
            tenant_id: searchForm.value.tenant_id,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await PartProjectTenantApi.getInstance().getList(params, page_num, page_size)
        if(res.code === 0){
            res.data.records.length > 0 && res.data.records.forEach(item=>{
                item.tenant = tenantObj[item.tenant_id]
            })
            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            message.error(res.msg || t('base.getDataFail'))
        }
    }


    const valid = ()=>{
        if(addForm.value.part_no === ''){
            message.error(t('partProjectTenant.part_no') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm.value.project_no === ''){
            message.error(t('partProjectTenant.project_no') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm.value.tenant_id === null){
            message.error(t('partProjectTenant.tenant') + ' ' + t('base.noEmpty'))
            return false
        }
        return true
    }


    const addPartProjectTenant = async()=>{
        if(!valid()) return

        let param = {
            part_no: addForm.value.part_no,
            project_no: addForm.value.project_no,
            tenant_id: addForm.value.tenant_id,
        }
        let res = operate_type.value == 'add'
                ? await PartProjectTenantApi.getInstance().addPartProjectTenant(param) 
                : await PartProjectTenantApi.getInstance().editPartProjectTenant(param, rowData.value.id)

        if(res.code === 0){
            message.success(t('base.saveSuccess'))
            visible.value = false
            getList()
        }else{
            message.error(res.msg || t('base.getDataFail'))
        }
    }

    const getTenantList = async()=>{
        let param = {
            limit_size: 100,
        }
        let res = await AdvancedFunApi.getInstance().getAllTenant2(param)
        if(res.code == 0){
            tenantOptions.value = res.data.length && res.data.map(item=>({ 
                label: item.tenant_name, 
                value: item.tenant_id 
            }))  

           res.data.length > 0 && res.data.forEach(item=>{
                tenantObj[item.tenant_id] = item.tenant_name
           })
        } else {
            message.error(res.msg || t('base.getDataFail'));
        }
    }


    onMounted(async()=>{
        await getTenantList()
        getList()
    })


</script>

<style lang="scss" scoped>

.operate_btn{
    margin-top: 50px;
}

.form_item{
    margin:10px 0;
    
    .required{
        color: red;
    }
}

:deep(.page_header .week) {
    margin-top: -48px !important;
}

:deep(.page_header .admin_email) {
    margin-top: -37.5px !important;
    margin-right: 70px !important;
}

::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}
</style>